<template>
  <div class="englobe-params">
    <div class="params-row">
      <!-- Back to index -->
      <GoBackButton go-back />
      <div
        v-if="store.previousAmendmentId || store.nextAmendmentId"
        class="previous-next-wrapper"
      >
        <!-- Next and Previous Items -->
        <RouterLink
          v-if="store.previousAmendmentId"
          v-focus
          :to="`/amendments/${store.previousAmendmentId}`"
          class="btn-primary previous"
        >
          <i class="fa-solid fa-chevron-left" />Précédent
        </RouterLink>
        <RouterLink
          v-if="store.nextAmendmentId"
          v-focus
          :to="`/amendments/${store.nextAmendmentId}`"
          class="btn-primary next"
        >
          Suivant<i class="fa-solid fa-chevron-right" />
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import GoBackButton from "@follaw-fr/components/general/atoms/GoBackButton.vue";
import { useAmendmentsStore } from "@/follaw-fr/stores/amendments";

const store = useAmendmentsStore();
</script>
